<template>
	<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 23.5 23.75">
		<path fill="currentColor" fill-rule="evenodd" d="M5.75 7A.75.75 0 0 1 5 6.25V.75a.75.75 0 0 1 1.5 0v5.5a.75.75 0 0 1-.75.75Z"/>
		<path fill="currentColor" fill-rule="evenodd" d="M17.75 7a.75.75 0 0 1-.75-.75V.75a.75.75 0 0 1 1.5 0v5.5a.75.75 0 0 1-.75.75Z"/>
		<path fill="currentColor" fill-rule="evenodd" d="M0 4a.75.75 0 0 1 .75-.75h22a.75.75 0 0 1 .75.75v19a.75.75 0 0 1-.75.75h-22A.75.75 0 0 1 0 23Zm1.5.75v17.5H22V4.75Z"/>
		<path fill-rule="evenodd" d="M4.75 10.5a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 0 1h-13a.5.5 0 0 1-.5-.5Z"/>
	</svg>
</template>
